/**
 * D2: "/i/:code opens the app (or the web landing -> store), the app stores the code and calls
 * claim automatically right after first login." This is the *web* landing's half of that — the
 * mobile app's own claim flow (useReferralDeepLinkCapture, built in Slice 2) only ever listens for
 * the live `getspeakhub://i/:code` custom-scheme deep link, not this storage; this is a
 * same-device fallback so a visitor who doesn't have the app yet, installs it later, and returns
 * to this same browser can still see/copy their code for the manual profile-screen entry field
 * (also built in Slice 2) instead of losing it.
 */
const STORAGE_KEY = 'gsh_referral_code';

export function storeReferralCode(code: string): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, code);
  } catch {
    // Storage can be unavailable (private browsing, disabled) — the deep link itself still works.
  }
}

export function getStoredReferralCode(): string | null {
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}
